<ion-header [translucent]="true">

    <ion-toolbar class="ion-padding-end">
        <ion-title slot="start">{{Title}}</ion-title>
        <ion-button style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end" (click)="Close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
    </ion-toolbar>

</ion-header>

<ion-content class="ion-padding">

    <div class="form-card">
        <ion-grid class="full ion-no-margin ion-no-padding">
            <form [formGroup]="Form" (ngSubmit)="OnSave()" novalidate>
                <ion-row>

                    <ion-col size="12" sizeMd="5">
                        <ion-item class="full" lines="full" fill="outline">
                            <ion-label position="stacked">Estado *</ion-label>
                            <ion-select class="outline" interface="popover" formControlName="IdStatus"
                                placeholder="Selecionar estado">
                                <ion-select-option [value]="item.Id" *ngFor="let item of Statuses">{{item.Name}}</ion-select-option>
                            </ion-select>
                        </ion-item>
                        <p class="field-error">
                            {{Form.get('IdStatus')?.touched && Form.get('IdStatus')?.hasError('required') ? 'Selecione um estado' : ''}}
                        </p>
                    </ion-col>

                    <ion-col size="12">
                        <ion-item class="full" lines="full" fill="outline">
                            <ion-label position="stacked">Observação</ion-label>
                            <ion-textarea formControlName="Observation" [maxlength]="ObservationMaxLength" rows="3"
                                placeholder="Opcional"></ion-textarea>
                        </ion-item>
                        <p class="field-hint">{{Form.get('Observation')?.value?.length || 0}} / {{ObservationMaxLength}}</p>
                    </ion-col>

                    <ion-col size="12" class="form-actions">
                        <ion-button type="button" fill="outline" color="medium" [disabled]="IsSubmitting || !Form.dirty"
                            (click)="OnClear()">
                            Limpar
                        </ion-button>
                        <ion-button type="submit" fill="solid" color="primary" [disabled]="Form.invalid || IsSubmitting">
                            Guardar
                        </ion-button>
                    </ion-col>

                </ion-row>
            </form>
        </ion-grid>
    </div>

    <p class="section-label history-label">
        Histórico <span class="count" *ngIf="TotalRegists > 0">({{TotalRegists}})</span>
    </p>

    <ion-grid class="ion-no-padding ion-no-margin table" *ngIf="Data?.length > 0">

        <ion-row class="table-header">
            <ion-col size="3" class="flex-align-center">Data</ion-col>
            <ion-col size="3" class="flex-align-center">Estado</ion-col>
            <ion-col class="flex-align-center">Observação</ion-col>
        </ion-row>

        <ion-row class="table-body" *ngFor="let item of Data">
            <ion-col size="3" class="flex-align-center">{{(item?.RegistDate | date: 'dd/MM/yyyy HH:mm') || '--'}}</ion-col>
            <ion-col size="3" class="flex-align-center">
                <div class="status-cell">
                    <ion-icon [name]="item?.Status?.Icon" [color]="item?.Status?.Color"></ion-icon>
                    <span>{{item?.Status?.Name || '--'}}</span>
                </div>
            </ion-col>
            <ion-col class="flex-align-center observation">{{item?.Observation || '--'}}</ion-col>
        </ion-row>

    </ion-grid>

    <no-items *ngIf="!IsLoading && Data?.length == 0" description="Sem histórico"></no-items>

    <ion-spinner *ngIf="IsLoading" class="loading" name="dots"></ion-spinner>

    <pagination-control *ngIf="IsPaginated && TotalRegists > 0" [page]="Filters.PageNumber" [itemsPerPage]="ItemsPerPage"
        [itemsForPageSelected]="Filters.PageRows" [totalItems]="TotalRegists" (pageChange)="OnChangePage($event)">
    </pagination-control>

</ion-content>

